import { VStack } from "@/components/ui/vstack";
import { View } from "@/components/ui/view";
import { Text } from "@/components/ui/text";
import { ScrollView } from "react-native-gesture-handler";
import i18n from "i18n-js";
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import FloatingLabelInput from "../../components/basic/FloatingLabelInput";
import ModalConfirm from "../../components/basic/ModalConfirm";
import PressableElement from "../../components/basic/PressableElement";
import useIsMounted from '../../hooks/mounted';
import { backendRequest, backendUploadImage } from '../../stores/thunks';
import { useSafeAreaInsets } from "react-native-safe-area-context";
import AvatarEdit from "../../components/media/AvatarEdit";
import avatar1 from "../../assets/images/avatar_mit_background.png"
import { Platform } from "react-native";
import { updateAvatar, logout } from "../../stores/mainSlice";

export default function Account({ isEdit, isAnonymous }) {
    const dispatch = useDispatch()
    const [showModal, setShowModal] = useState(false)

    const mounted = useIsMounted()
    const insets = Platform.OS == 'web' ? { bottom: 0, left: 0, right: 0, top: 0 } : useSafeAreaInsets()

    const server = useSelector((state) => state.server)
    const user = useSelector((state) => state.user)
    const [name, setName] = useState(isAnonymous ? user.publicName : (user.name ? user.name : ''))
    const [image, setImage] = useState(isAnonymous ? (user.publicImage?.id || avatar1) : user.avatar)
    const [wasEdit, setWasEdit] = useState(false)

    const selected = async (uri) => {
        setImage(uri)
    }

    const checkAndSave = () => {
        if (image != (isAnonymous ? user.publicImage?.id || avatar1 : user.avatar)) {
            dispatch(backendUploadImage(isAnonymous ? 'IMAGE_PUBLIC' : 'IMAGE_AVATAR', isAnonymous ? '/user/userPublic' : '/user/userImage', { uri: image, title: (isAnonymous ? 'Anonymous ' : 'Avatar ') + user.preferredName, description: 'user image' }, 'POST', true))
                .then(result => {
                    if (!isAnonymous) {
                        if (null != result) {
                            if (mounted()) {
                                setImage(user.id)
                            }
                        } else {
                            dispatch(updateAvatar({ avatar: image }))
                        }
                    }
                })
        }
        if (name != (isAnonymous ? user.publicName : user.name)) {
            dispatch(backendRequest('UPDATE_USER', '/user', isAnonymous ? { publicName: name } : { preferredName: name }, 'PUT', true))
        }
    }

    useEffect(() => {
        if (wasEdit) {
            checkAndSave()
        }
        setWasEdit(isEdit)
    }, [isEdit])

    useEffect(() => {
        setName(isAnonymous ? user.publicName : user.name)
        setImage(isAnonymous ? user.publicImage?.id || avatar1 : user.avatar)
    }, [isAnonymous])

    const closeModal = (confirmed) => {
        setShowModal(false)
        if (confirmed) {
            dispatch(backendRequest('DELETE_USER', '/user/block', '', 'PUT', false)).then(() => {
                // TODO logout is not handled by mainSlice on DELETE_USER action - check state reset there
                dispatch(logout({clean: true}))
            })
        }
    }

    return (
        <View className="flex-1 bg-secondary-50">
            <ScrollView scrollIndicatorInsets={{ right: 1 }} contentContainerStyle={{ paddingBottom: 90 + insets.bottom }} className="flex-1 bg-secondary-50 py-3 px-3">
                <VStack space='2xl' className="flex-1 bg-secondary-50">
                    <VStack space='xl' className="flex-1 pb-1">
                        <Text className="text-2xl leading-2xl text-secondary-900">{i18n.t(isAnonymous ? 'accountSettings.public' : 'accountSettings.personal')}</Text>
                        {image &&
                            <AvatarEdit key={user.updated} uri={image} selected={selected} sync={isAnonymous ? '/contact/media/' + image : '/user/userImage/'} isEdit={isEdit} />
                        }
                        <View className="px-3">
                            <FloatingLabelInput label={i18n.t('accountSettings.preferredName')} value={name} placeholder={i18n.t('accountSettings.preferredName')} onChangeText={setName} isDisabled={!isEdit} />
                        </View>
                        {!isAnonymous && <View className="px-3">
                            <FloatingLabelInput label={i18n.t('accountSettings.email')} value={user.mail ? user.mail : ''} placeholder={i18n.t('accountSettings.email')} isDisabled />
                        </View>}
                        <View className="px-3">
                            <FloatingLabelInput size='md' label={i18n.t('accountSettings.hint')} h={isAnonymous ? 'h-[150px]' : 'h-[250px]'} multiline={true} isDisabled={true} value={i18n.t(isAnonymous ? 'accountSettings.hintPublic' : 'accountSettings.hintPersonal')} />
                        </View>
                        {!isAnonymous && isEdit && server.online && <VStack space='xl' className="flex-1 py-1">
                            <Text className="text-2xl leading-2xl text-secondary-900">{i18n.t('accountSettings.account')}</Text>
                            <PressableElement mainText={i18n.t('accountSettings.deleteAccount')} className="text-error-600" pressed={() => setShowModal(true)} />
                        </VStack>}
                    </VStack>
                </VStack>
            </ScrollView>
            <ModalConfirm showModal={showModal} closeModal={closeModal} title='accountSettings.deleteAccount' text='modalDeleteAccount.text' />
        </View>
    );
}
